import React from 'react'
import {InsertPhoto, VisDiv, HorizontalSwipeSanity, InsertPhotoSanity} from './'
import { useStateContext } from '../context/StateContext'
import useNetworkStatus from '../hooks/useNetworkStatus'
import { clientUser, facilityClient } from '../lib/userPermissions'


const Photos = ({destination, saveFn, saveSanityFn, iconOnlyLeft}) => { 
    const { LDB, client, sUser } = useStateContext();
    const networkStatus = useNetworkStatus()
    const testing = false
    const testFunction = () => {
        //console.log(arrayNameIndex)
    }
    const images = () => {

        if (!destination?.images) return []
        return destination?.images
    }
    //console.log("CONSOLE IMAGE", destination?.image?.length)
    return(
      <VisDiv className='new-device-container-top' style={{marginTop:"5px", marginBottom:"5px",}}>
            <div className='title-with-side-icons'>
                <VisDiv rules={[!iconOnlyLeft]}></VisDiv>
                <VisDiv rules={[!iconOnlyLeft]}> <h2> {LDB("misc", "photos")}</h2></VisDiv>
                <VisDiv rules={[false, networkStatus, facilityClient(client, sUser), clientUser(sUser)]}>
                    <InsertPhotoSanity
                        saveSanityFn={saveSanityFn}
                    /> 
                </VisDiv>
                <VisDiv rules={[false, !networkStatus, facilityClient(client, sUser), clientUser(sUser)]}>
                    <InsertPhoto
                        saveFn={saveFn}
                    />
                </VisDiv>
                <VisDiv rules={[true]}></VisDiv>
                <VisDiv rules={[!facilityClient(client, sUser)]}></VisDiv>
            </div>
            {!iconOnlyLeft &&
                <HorizontalSwipeSanity
                images={destination?.image}
                offlineImages={images()}
            />
            }

            <VisDiv rules={[testing]}>
                <button onClick={testFunction}> test </button>
            </VisDiv>

            <VisDiv rules={[destination?.image?.length < 1 || !destination?.image, !iconOnlyLeft]}>
                <div className='horizontal-swipe-box' style={{ border: "2px dashed", borderRadius:"10px", height: "120px", width:"120px", display:"flex", alignItems:"center" }}>
                    {LDB("misc", "noPhotos")}
                </div>
            </VisDiv>
      </VisDiv>
    )
}

export default Photos
